var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 0H8.235C8.343 0.53625 8.64 1.21275 9.16125 1.884C9.67125 2.54175 10.3478 3 11.25 3V4.5C9.93525 4.5 8.9475 3.8895 8.25 3.12825V8.25C8.25 8.99168 8.03007 9.7167 7.61801 10.3334C7.20596 10.9501 6.62029 11.4307 5.93507 11.7145C5.24984 11.9984 4.49584 12.0726 3.76841 11.9279C3.04098 11.7833 2.3728 11.4261 1.84835 10.9017C1.3239 10.3772 0.966751 9.70902 0.822057 8.98159C0.677362 8.25416 0.751625 7.50016 1.03545 6.81494C1.31928 6.12971 1.79993 5.54404 2.41661 5.13199C3.0333 4.71993 3.75832 4.5 4.5 4.5V6C4.05499 6 3.61998 6.13196 3.24997 6.37919C2.87996 6.62643 2.59157 6.97783 2.42127 7.38896C2.25098 7.8001 2.20642 8.2525 2.29323 8.68895C2.38005 9.12541 2.59434 9.52632 2.90901 9.84099C3.22368 10.1557 3.62459 10.37 4.06105 10.4568C4.49751 10.5436 4.94991 10.499 5.36104 10.3287C5.77217 10.1584 6.12358 9.87004 6.37081 9.50003C6.61804 9.13002 6.75 8.69501 6.75 8.25V0Z",
    fill: "#0A490A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.5d28073ca02e4221fc816a92931a4fff.svg";
export { ForwardRef as ReactComponent };